<template>
  <el-config-provider>
    <router-view />
  </el-config-provider>
</template>
<script setup lang="ts">

</script>

<style lang="scss">
body {
  background: #000;
  margin: 0;
}

li {
  list-style: none;
  margin: 0;
  padding: 0;
}
.el-popper.is-pure {
  border: 0px solid !important;

}
.el-sub-menu__title{
  padding-left: 0px !important;
}

.el-sub-menu .el-icon {
  font-size: 16px !important;
  font-weight: 700 !important;
}

.el-menu--popup {
  padding: 0px !important;
  border: 30px;
}
p {
  margin: 0;
  padding: 0;
}

.el-dialog__header{
    padding: 0px !important;
}
.el-drawer{
    background: rgba(31, 32, 36, 1) !important;
}
.el-popper.is-pure {
background: transparent !important;

}
</style>
